import React from 'react';
import NotFound from 'components/notFound';

const NotFoundContainer = () => {
  return (
    <div>
      <NotFound />
    </div>
  );
};

export default NotFoundContainer;
